export const LOCAL_STORAGE_LOCALE = 'locale';
export const LOCAL_STORAGE_AUTHORIZED_KEY = 'authorized';
export const LOCAL_STORAGE_AUTHORIZED_SESSION_KEY = 'session';
export const LOCAL_STORAGE_AUTHORIZED_REFRESH_KEY = 'refresh_session';
export const LOCAL_STORAGE_AUTHORIZED_SESSION_TIMEOUT = 'stm';
export const LOCAL_STORAGE_UPDATE_PERIOD = 'update-period';
